import type { TextareaHTMLAttributes } from "react";
import styles from "./Textarea.module.scss";
import cn from "classnames";

type TextareaProps = {
  valid?: boolean;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = ({ valid = true, className, ...props }: TextareaProps) => {
  return (
    <div className={cn(styles.wrapper)}>
      <textarea
        className={cn(
          styles.textarea,
          {
            [styles.invalid]: !valid,
          },
          className
        )}
        {...props}
      />
    </div>
  );
};
